import { ModeActionType } from './modeTypes';

export const setCurrentServeType: (serveType) => any =
  (serveType) => async (dispatch) => {
    dispatch({
      type: ModeActionType.SET_CURRENT_SERVETYPE,
      payload: serveType,
    });
  };

export const setProjectName: (projectName) => any =
  (projectName) => async (dispatch) => {
    dispatch({
      type: ModeActionType.SET_PROJECT_NAME,
      payload: projectName,
    });
  };

export const setCustomizedServeType: (customizedServeType) => any =
  (customizedServeType) => async (dispatch) => {
    dispatch({
      type: ModeActionType.SET_CUSTOMIZED_SERVETYPE,
      payload: customizedServeType,
    });
  };
